import ExportedImage from 'next-image-export-optimizer';
import Link from 'next/link';

import AnimateWhileInView from '@/components/shared/AnimateWhileInView';
import BgEllipse from '@/components/shared/lp/BgEllipse';

import { siteData } from '@/data/site';
import discordCard from '@/public/images/lp/community/discord-card.png';
import komodoCommunityCurrency from '@/public/images/lp/community/komodo-community-currency.png';
import komodoHandbook from '@/public/images/lp/community/komodo-handbook.png';
import logoStairs from '@/public/images/lp/community/logo_stairs.png';
import redditCard from '@/public/images/lp/community/reddit-card.png';
import telegramCard from '@/public/images/lp/community/telegram-card.png';
import twitterCard from '@/public/images/lp/community/x-card.png';
import discord from '@/public/images/lp/index/discord.png';
import reddit from '@/public/images/lp/index/reddit.png';
import telegram from '@/public/images/lp/index/telegram.png';
import twitter from '@/public/images/lp/index/twitter.png';
import gradientLinkArrow from '@/public/images/lp/svgs/gradient-link-arrow.svg';

const socialIcons = [
  {
    name: 'Discord',
    icon: discord,
    link: siteData.social.discord,
    lgWidth: 90.21,
    smWidth: 50.21,
  },
  {
    name: 'X.com',
    icon: twitter,
    link: siteData.social.twitter,
    lgWidth: 125.21,
    smWidth: 70.21,
  },
  {
    name: 'Reddit',
    icon: reddit,
    link: siteData.social.reddit,
    lgWidth: 125.21,
    smWidth: 70.21,
  },
  {
    name: 'Telegram',
    icon: telegram,
    link: siteData.social.telegram,
    lgWidth: 125.21,
    smWidth: 70.21,
  },
];

export default function Community() {
  const sections = [
    {
      imageSrc: '/images/kp/community/userSupport.png',
      imageAlt: 'Komodo Handbook',
      imageWidth: 446,
      imageHeight: 245,
      title: 'Why Komodo Community?',
      description: `Komodo is a community-focused blockchain project for passionate, dedicated, and
      inquisitive tech enthusiasts. Join our community to get involved in a thriving
      ecosystem working towards our goals of freedom and self-sovereignty. Be a part
      of shaping the future of Komodo's technology and growth. Together we build
      blockchain technologies and educate the public on the benefits of creating a
      more decentralized world.`,
      reverse: false,
    },
    {
      imageSrc: '/images/kp/illustration/currency.png',
      imageAlt: 'KMD Community Currency',
      imageWidth: 476,
      imageHeight: 276,
      title: 'Komodo Community Currency',
      description: `KMD can be traded on popular cryptocurrency exchanges and used for payments at a
      variety of physical stores and online retailers.`,
      buttons: [
        {
          href: '/en/wallet/',
          text: 'Browse wallets',
          target: '_blank',
        },
        {
          href: 'https://markets.komodoplatform.com/',
          text: 'Browse Markets',
          target: '_blank',
        },
      ],
      reverse: true,
    },
    {
      imageSrc: '/images/kp/illustration/handbook.png',
      imageAlt: 'Komodo Handbook',
      imageWidth: 446,
      imageHeight: 245,
      title: 'Komodo Handbook',
      description: `Learn everything you need to know about Komodo's technology and how you can
      get involved with the community.`,
      buttons: [
        {
          href: 'https://komodoplatform.com/en/blog/komodo-handbook/',
          text: 'Explore Komodo',
          target: '_blank',
        },
      ],
      reverse: false,
    },
  ];

  return (
    <>
      <div className='absolute z-[11] h-full w-full overflow-hidden'>
        <ExportedImage
          src='/svg/gradients/community/snake-gradient.svg'
          className='absolute left-0 top-0 h-full w-full'
          width={1000}
          height={1000}
        />
        <ExportedImage
          src='/svg/gradients/community/snake-gradient-2.svg'
          className='absolute bottom-0 h-full w-full'
          width={1000}
          height={1000}
        />
        {/* <div className='index-ellipse-1 absolute z-[-10]'></div>
    <div className='index-ellipse-2 absolute z-[-10]'></div>
    <div className='index-ellipse-3 absolute z-[-10]'></div>
    <div className='index-ellipse-4 absolute z-[-10]'></div> */}
      </div>
      <main className='container relative z-[100] mx-auto font-sans text-white md:grid md:grid-cols-24 md:gap-0'>
        <div className='lp-ellipse-223 absolute right-[0px] top-[-300px] z-[-10] h-[585px] w-[560px] -sm:top-[-500px]'></div>

        <div className='lp-ellipse-239 absolute bottom-[-200px] left-[-300px] z-[-10] h-[910px] w-[875px]'></div>

        {/* <div className='lp-ellipse-224 absolute left-[-100px] top-[163px] z-[-10] h-[515px] w-[492px] -sm:left-[-300px] -sm:top-[400px]'></div>
        <div className='lp-ellipse-232 absolute right-[-200px] top-[800px] z-[-10] h-[733px] w-[700px] -sm:right-[-300px]'></div> */}

        {/* <BgEllipse className='right-[-80px] top-[-600px]' />
      <BgEllipse className='left-[-600px]' /> */}
        <div className='dummy hidden w-[50.21px] w-[70.21px] lg:w-[125.21px] lg:w-[90.21px]'></div>
        <div className='hidden xl:col-span-2 xl:block'></div>
        <div className='relative w-full max-w-7xl px-4 xs:px-8 md:col-span-24 md:mx-auto xl:col-span-20 xl:px-0'>
          <section className='flex flex-col items-center justify-center bg-[url(/svg/gradients/community/mesh.svg)] pt-24 md:pt-36 lg:flex-row lg:pt-36'>
            <div className='relative z-10 mx-auto max-w-[800px] text-center'>
              <h1 className='flex flex-col font-heading text-5xl font-semibold md:leading-[4rem] lg:text-6xl lg:leading-[4rem] 2xl:text-[73px] 2xl:leading-none 3xl:text-8xl'>
                <span className='bg-gradient-to-r from-[#12FFE3] via-[#5E50FF] to-[#BD4EF1] bg-clip-text font-bold text-transparent'>
                  Event-first
                </span>{' '}
                Community
              </h1>
              <p className='text-2xl leading-[38.4px] text-[#787A8B] lg:text-[32px]'>
                %100 Degen, %100 Komodian.
              </p>
              <p className='mt-4 text-2xl leading-[33px] lg:text-[22px]'>
                Komodo is a community of hackers, developers, entrepreneurs, and enthusiasts pushing
                the boundaries of blockchain technology.
              </p>
            </div>
          </section>
          {/* <section className='border-3 relative z-10 mx-auto flex max-w-[1200px] flex-col items-center justify-between gap-10 rounded-[14px] border border-[#3DBAA5] bg-[rgba(5,16,25,0.45)] mt-[100px] p-10 px-20 backdrop-blur-[22.15px] md:flex-row'>
          <ExportedImage
            src='/svg/gradients/community/edge-reflection.svg'
            width={100}
            height={100}
            className='absolute left-32 top-[-11px]'
          />
          <h1 className='max-w-md flex-1 text-center text-3xl font-[600] md:text-left md:text-[48px] md:leading-[66px]'>
            Join the community
          </h1>
          <div className='mx-auto flex w-[341px] flex-row items-center justify-center  2xs:w-full md:w-[633px]  lg:w-auto lg:gap-x-[30.49px]  -sm:flex-wrap -sm:justify-between -sm:gap-y-8'>
            {socialIcons.map((social, i) => {
              const { name, icon, link, lgWidth, smWidth } = social;
              return (
                <AnimateWhileInView delay={(i + 2) * 0.1} key={social.name}>
                  <Link
                    href={link}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='all-index-join_community-discord flex flex-col items-center'
                  >
                    <ExportedImage
                      src={icon}
                      alt={name}
                      className={`h-auto  w-[${smWidth}px]`}
                    />
                    <p className='text-center text-[18px] font-normal leading-[24.85px] lg:text-[20.98px]'>
                      {name}
                    </p>
                  </Link>
                </AnimateWhileInView>
              );
            })}
          </div>
        </section> */}
          <section className='mx-auto my-[40px] max-w-[1200px] lg:my-[80px] 2xl:my-[100px]'>
            <ul className='flex flex-row items-center justify-between gap-10 -lg:grid -lg:grid-cols-2 -lg:justify-center -lg:text-center'>
              <div className='text-xl md:text-4xl'>
                <span
                  className='bg-gradient-to-r bg-clip-text text-transparent'
                  style={{ backgroundImage: 'linear-gradient(90deg, #EF87FD, #CEA336)' }}
                >
                  Rewards
                </span>
              </div>

              <div className='text-xl md:text-4xl'>
                <span
                  className='bg-gradient-to-r bg-clip-text text-transparent'
                  style={{ backgroundImage: 'linear-gradient(90deg, #1547A9, #97A1F5)' }}
                >
                  AMA&apos;s
                </span>
              </div>

              <div className='text-xl md:text-4xl'>
                <span
                  className='bg-gradient-to-r bg-clip-text text-transparent'
                  style={{ backgroundImage: 'linear-gradient(90deg, #8217A6, #EF87FD)' }}
                >
                  Giveaways
                </span>
              </div>

              <div className='text-xl md:text-4xl'>
                <span
                  className='bg-gradient-to-r bg-clip-text text-transparent'
                  style={{ backgroundImage: 'linear-gradient(90deg, #D69DFF, #FFBC05)' }}
                >
                  IRL Events
                </span>
              </div>
            </ul>
          </section>
          <section className='relative z-10 mx-auto mt-32 grid max-w-[1200px] items-center gap-20 lg:grid-cols-2'>
            <div className=''>
              <div className='lg:max-w-[600px] -lg:text-center'>
                <h1 className='text-3xl font-[600] tracking-[2px] md:text-[48px] md:leading-[58px]'>
                  Why Komodo Community?
                </h1>
                <p className='mb-8 mt-4 text-[18px] leading-[24px]'>
                  Komodo is a community-focused blockchain project for passionate, dedicated, and
                  inquisitive tech enthusiasts. Join our community to get involved in a thriving
                  ecosystem working towards our goals of freedom and self-sovereignty. Be a part of
                  shaping the future of Komodo&apos;s technology and growth. Together we build
                  blockchain technologies and educate the public on the benefits of creating a more
                  decentralized world.
                </p>
                <Link
                  href={siteData.social.discord}
                  target='_blank'
                  className='cta-btn mt-8 rounded-[14px] px-4 py-4 text-white'
                >
                  Join now
                </Link>
              </div>
            </div>
            <ExportedImage
              className='hidden w-[70%] lg:absolute lg:right-0 lg:top-0 lg:block'
              src={logoStairs}
            />
          </section>

          <section className='relative z-10 mx-auto max-w-[1200px] py-32'>
            <ul className='grid gap-10 lg:grid-cols-2'>
              <li
                key={'komodo-community-currency'}
                className='relative flex flex-col rounded-[17.817px] bg-[rgba(5,16,25,0.60)] backdrop-blur-[50.14px]'
              >
                <ExportedImage src={komodoCommunityCurrency} className='h-auto w-full' />
                <div className='absolute bottom-0 flex flex-1 flex-col justify-between space-y-5 p-10'>
                  <p className='w-max rounded-[24.604px] border border-[#1F79AB] bg-gradient-to-tr from-[#1F79AB] to-[#10181E] px-4 py-1'>
                    Time to Hodl, Komodian
                  </p>
                  <h1 className='text-2xl font-[600] xs:text-3xl lg:text-[40px]'>
                    Komodo Community Currency
                  </h1>
                  <p>
                    KMD can be traded on popular cryptocurrency exchanges and used for payments at a
                    variety of physical stores and online retailers.
                  </p>
                  <Link
                    href={'/en/wallet/'}
                    target='_blank'
                    className='block w-max bg-gradient-to-r from-[#12FFE3] to-[#5E50FF] bg-clip-text font-[600] text-transparent'
                  >
                    <div className='flex flex-row items-center'>
                      <span className='bg-gradient-to-r from-[#12FFE3] via-[#5E50FF] to-[#BD4EF1] bg-clip-text font-bold text-transparent'>
                        Browse Wallets/Markets
                      </span>{' '}
                      <ExportedImage
                        src={gradientLinkArrow}
                        className='ml-2 h-[19px] w-auto'
                        width={16}
                        height={17}
                        alt='link'
                      />
                    </div>
                  </Link>
                </div>
              </li>
              <li
                key={'komodo-handbook'}
                className='flex flex-col rounded-[17.817px] border-[0.848px] border-[#1D4B6C] bg-[rgba(5,16,25,0.60)] backdrop-blur-[50.14px]'
              >
                <ExportedImage src={komodoHandbook} className='w-full flex-1' />
                <div className='-mt-10 flex flex-1 flex-col justify-between space-y-5 px-10 pb-10'>
                  <p className='w-max rounded-[24.604px] border border-[#1F79AB] bg-gradient-to-tr from-[#1F79AB] to-[#10181E] px-4 py-1'>
                    Dive into ecosystem
                  </p>
                  <h1 className='text-2xl font-[600] xs:text-3xl lg:text-[40px]'>
                    Komodo Handbook
                  </h1>
                  <p>
                    Learn everything you need to know about Komodo&apos;s technology and how you can
                    get involved with the community.
                  </p>
                  <Link
                    href={'https://komodoplatform.com/en/blog/komodo-handbook/'}
                    target='_blank'
                    className='block w-max bg-gradient-to-r from-[#12FFE3] to-[#5E50FF] bg-clip-text font-[600] text-transparent'
                  >
                    <div className='flex flex-row items-center'>
                      <span className='bg-gradient-to-r from-[#12FFE3] via-[#5E50FF] to-[#BD4EF1] bg-clip-text font-bold text-transparent'>
                        Read now
                      </span>{' '}
                      <ExportedImage
                        src={gradientLinkArrow}
                        className='ml-2 h-[19px] w-auto'
                        width={16}
                        height={17}
                        alt='link'
                      />
                    </div>
                  </Link>
                </div>
              </li>
            </ul>
          </section>
          <section className='mx-auto my-[40px] max-w-[1400px] space-y-10 lg:my-[80px] 2xl:my-[100px]'>
            <h1 className='text-left text-3xl font-[600] md:text-center md:text-[48px]'>
              Click to join our community
            </h1>
            <ul className='grid gap-10 md:grid-cols-4'>
              <Link className='' href={siteData.social.discord} target='_blank'>
                <ExportedImage src={discordCard} className='h-auto w-full' />
              </Link>
              <Link className='' href={siteData.social.reddit} target='_blank'>
                <ExportedImage src={redditCard} className='h-auto w-full' />
              </Link>
              <Link className='' href={siteData.social.telegram} target='_blank'>
                <ExportedImage src={telegramCard} className='h-auto w-full' />
              </Link>
              <Link className='' href={siteData.social.twitter} target='_blank'>
                <ExportedImage src={twitterCard} className='h-auto w-full' />
              </Link>
            </ul>
          </section>
        </div>
        <div className='hidden xl:col-span-2 xl:block'></div>
      </main>
    </>
  );
}
